// extracted by mini-css-extract-plugin
export default {"container":"_e095dee2","label":"_a10481c3","invalidDoc":"_d0d1461c","invalidDocText":"_88ae9f81","eligibleForTaxExemption":"_442722cf"};